import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { cn } from '../../lib/utils';

interface RecommendedByAIProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'compact';
}

const RecommendedByAI: React.FC<RecommendedByAIProps> = ({ 
  className,
  size = 'md',
  variant = 'default'
}) => {
  const sizeClasses = {
    sm: 'px-2 py-1 text-[var(--font-size-xs)]',
  md: 'px-3 py-2 text-[var(--font-size-sm)]',
  lg: 'px-4 py-3 text-[var(--font-size-base)]'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4', 
    lg: 'w-5 h-5'
  };

  return (
    <div className={cn(
      'inline-flex items-center gap-2 rounded-full',
      'bg-gradient-to-r from-purple-100 to-pink-100',
      'border border-purple-200',
      'text-[var(--amazon-orange)] font-[var(--font-weight-medium)]',
      'shadow-sm hover:shadow-md transition-all duration-200',
      'backdrop-blur-sm',
      sizeClasses[size],
      variant === 'compact' && 'gap-1',
      className
    )}>
      <SparklesIcon className={cn(
        iconSizes[size],
        'text-[var(--amazon-orange)] flex-shrink-0'
      )} />
      <span className="whitespace-nowrap">
        {variant === 'compact' ? 'AI' : 'Recommended by AI'}
      </span>
    </div>
  );
};

export default RecommendedByAI;